import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all failureCodes
export const getFailureCodes = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/failure-codes`);
    return response.data;
  } catch (error) {
    console.error("Error fetching failure-codes:", error.response?.data || error);
    throw error;
  }
};

// GET a single failureCode
export const getFailureCodeById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/failure-codes/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching failureCode:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new failureCode
export const createFailureCode = async (failureCodeData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/failure-codes`, failureCodeData);
    return response.data;
  } catch (error) {
    console.error("Error creating failure-codes:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing failureCode
export const updateFailureCode = async (id, failureCodeData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/failure-codes/${id}`, failureCodeData);
    return response.data;
  } catch (error) {
    console.error("Error updating failure-codes:", error.response?.data || error);
    throw error;
  }
};

// DELETE a failureCode
export const deleteFailureCode = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/failure-codes/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting failure-codes:", error.response?.data || error);
    throw error;
  }
};

// CHECK if a failureCode already exists
export const checkFailureCodeExists = async (code, excludeId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/failure-codes/check-duplicate`, {      params: { code, excludeId },
    });
    return response.data;
  } catch (error) {
    console.error("Error checking failure-code duplicate:", error.response?.data || error);
    throw error;
  }
};
